<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">
        <b-form>
          <b-form-group
            label="Nombre:"
            label-for="nombre"
            :label-cols="2"
            horizontal>
            <b-form-input 
              id="nombre" 
              v-model= "nombre" 
              type="text">
            </b-form-input>
          </b-form-group>
        </b-form>
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <b-table hover  
            responsive="sm" 
            class="registro"
            :busy="tableBusy"
            :items="remitosDestinos" 
            :fields="remitosDestinosFields"
            :filter="nombre"
            :current-page="paginaActual"
            :per-page="registrosPorPagina"
            @filtered="onFiltered"
            @row-clicked="seleccionarRemitoDestino">
          <div slot="table-busy" class="text-center">
            <b-spinner class="table-spinner" label="Spinning" />
          </div>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" xl="12">  
        <nav>
          <b-pagination size="sm" 
            :total-rows="totalRegistros" 
            :per-page="registrosPorPagina" 
            v-model="paginaActual" 
            prev-text="Prev." next-text="Prox."/>
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
  name: 'RemitosDestinosSearchList',
  props: {
  },
  data: () => {
    return {
      remitosDestinos: [],
      remitosDestinosFields: [
        {
          key: 'id',
          label: 'Cód.'
        },
        {
          key: 'nombre',
          sortable: true
        },
        {
          key: 'documento',
          sortable: true
        },
        {
          key: 'direccion',
          sortable: true
        },
      ],

      loaded: false,
      tableBusy: false,

      /* Info de paginación */
      paginaActual: 1,
      totalPaginas: 1,
      registrosPorPagina: 5,
      totalRegistros: 0,

      nombre: null,
    }
  },
  computed: {
  },
  created() {
    this.getRemitosDestinos();
  },  
  methods: {
    getRemitosDestinos() {
      this.tableBusy = true;
      this.$store.dispatch('remitosdestinos/getList')
        .then(() => {
          this.remitosDestinos = this.$store.getters['remitosdestinos/list'];
          this.totalRegistros = this.remitosDestinos.length;
          this.tableBusy = false;
        })
    },
    seleccionarRemitoDestino (item) {
      this.$emit('remitoDestinoSeleccionado', item)
    },
    onFiltered(filteredItems) {
      this.totalRegistros = filteredItems.length
      this.paginaActual = 1
    }    
  },
}
</script>

<style>
</style>
